import Swiper from 'swiper'
import registerFCInstagram from './instagramCodigoBase'

export default function instagramApi() {
	const instaWrapper = document.querySelector('#instafeed')
	if (!instaWrapper) return

	registerFCInstagram()

	jQuery.fn.FCInstagram.accessData = {
		accessToken:
			'IGAASPEiRjZBYFBZAFlTN2dmcGNNSVczejB4RkVhSjNPTGVjVGt3aTdkNlQyYmpCRGt0WUc0azBlU24xX0JVZAkY5aXZAFMmhXbHpjTHpMVm4wcjMzWFFKQXJ4NDV4c2Vha1dpcEF0R0pBVTZA2bzhSR0NYTEd6V2dxai1CRXZAldkdoawZDZD',
	}

	$('#instafeed').FCInstagram({
		max: 10,
		autoplay: true,
		complete: function () {
			const instaItems = document.querySelectorAll('#instafeed a')

			const htmlSlide = [...instaItems]
				.map((item) => {
					return `
                <div class="swiper-slide">
                        <span style="visibility:hidden">-</span>
                        <div>
                            ${item.outerHTML}    
                            <div class="content">
                            <svg>
                                <use xlink:href="#icon_instagram_white"></use>
                            </svg>
                            <span class="text-white">Ver no instagram</span>
                            </div>
                        </div>
                </div>
                `
				})
				.join('')

			instaWrapper.innerHTML = `          
            <div class="swiper swiper-acompanhe-nos" style="display: grid; width:100%;">
                <div class="swiper-wrapper">
                ${htmlSlide}
                </div>
            </div>
            `

			new Swiper('.swiper-acompanhe-nos', {
				lazy: true,
				slidesPerView: 'auto',
				spaceBetween: 8,
				centeredSlides: true,
				centeredSlidesBounds: true,
			})
		},
	})
}
